<template>
  <div class="base-form-div">
    <el-form
      size="mini"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="接收方卡号" prop="cardNumber">
        <el-input :disabled="false" placeholder="请输入接收方卡号" v-model="ruleForm.cardNumber"></el-input>
      </el-form-item>
      <div class="form-bottom">
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          @click="submitForm('ruleForm')"
          >发送</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { getCommonAjax } from "@/api/common";
export default {
  props: ["subData"],
  data() {
    return {
      ruleForm: {
        rwCode: undefined,
        cardNumber: "",
      },
      rules: {
        cardNumber: [{ required: true, message: "请输入接收方卡号", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          getCommonAjax("/wxrw/sendRw", {
            rwCode: this.ruleForm.rwCode,
            cardNumber: this.ruleForm.cardNumber,
          })
            .then((res) => {
              this.$message({
                message: "任务下发成功",
                type: "success",
              });
              this.$bus.$emit("task-list");
              this.$parent.close();
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  created() {
    this.ruleForm = this.subData;
  },
  mounted() {},
};
</script>
<style>
.form-bottom {
  margin-bottom: 0 !important;
  text-align: center;
}

.el-input-number {
  width: 100%;
}
</style>
